import { useEffect, useCallback, KeyboardEventHandler } from 'react';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const useRemoveDevice = (onClose: ICloseEvent['onClose']) => {
    const { subusers, devices, lang } = useStore();
    const key = useKeyDown();

    const handleConfirmClick = useCallback(() => {
        subusers.resetServerError();
        subusers.removeDevice();
    }, []);
    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
            case 'Enter':
                handleConfirmClick();
                break;
        }
    };
    const handleBtnKeyDown: KeyboardEventHandler<HTMLElement> = useCallback(
        (e) => {
            const { key } = e;
            if (key === 'Enter') {
                e.stopPropagation();
                e.preventDefault();
                const target = e.target as HTMLElement;
                target.click();
            }
        },
        [],
    );
    const handlers = {
        handleConfirmClick,
        handleBtnKeyDown,
    };

    useEffect(() => {
        subusers.resetServerError();
        if (subusers.operationSuccess) {
            subusers.resetOperationSuccess();
        }
    }, []);
    useEffect(() => {
        if (subusers.operationSuccess) {
            onClose();
            subusers.resetOperationSuccess();
            subusers.getSubusers();
        }
    }, [subusers.operationSuccess]);
    useEffect(() => {
        handleKey(key);
    }, [key]);
    useEffect(() => {
        if (!subusers.selectedSubuser && !subusers.loading) {
            onClose();
        }
    }, [subusers.selectedSubuser, subusers.loading]);
    useEffect(() => {
        const [subuser] = subusers.subusersDevices.filter(
            ({ subuser }) => subuser === subusers.selectedSubuser,
        );
        const { selectedDevice } = subusers;
        if (!selectedDevice) return;
        else if (
            subuser &&
            !subuser.devices.includes(selectedDevice) &&
            !subusers.loading
        ) {
            onClose();
        }
    }, [subusers.subusersDevices, subusers.loading]);

    return {
        subusers,
        devices,
        lang,
        handlers,
    };
};

export default useRemoveDevice;
